// src/agents/agent-registry.ts
function defineAgent(def) {
  return def;
}
var PRESET_AGENTS = [
  defineAgent({
    id: "keyword-analyst",
    name: "\uD0A4\uC6CC\uB4DC \uBD84\uC11D\uAC00",
    description: "\uD0A4\uC6CC\uB4DC \uAC80\uC0C9\uB7C9, \uD2B8\uB80C\uB4DC, \uACBD\uC7C1\uB3C4\uB97C \uBD84\uC11D\uD574 \uAE30\uD68C \uD0A4\uC6CC\uB4DC\uB97C \uCC3E\uC544\uB0C5\uB2C8\uB2E4.",
    icon: "BarChart3",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB370\uC774\uD130\uB7A9\uD234\uC988\uC758 \uD0A4\uC6CC\uB4DC \uBD84\uC11D \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uC0AC\uC6A9\uC790\uC758 \uD0A4\uC6CC\uB4DC\uB97C \uAC80\uC0C9\uB7C9/\uD2B8\uB80C\uB4DC/\uACBD\uC7C1\uB3C4/\uC785\uCC30\uAC00 \uAD00\uC810\uC5D0\uC11C \uBD84\uC11D\uD558\uACE0,
\uAE30\uD68C \uD0A4\uC6CC\uB4DC\uC640 \uC800\uD3C9\uAC00 \uD0A4\uC6CC\uB4DC\uB97C \uCC3E\uC544 \uAD6C\uCCB4\uC801\uC778 \uC561\uC158\uC744 \uC81C\uC548\uD569\uB2C8\uB2E4.
\uBC18\uB4DC\uC2DC \uB370\uC774\uD130 \uAE30\uBC18\uC73C\uB85C \uB2F5\uBCC0\uD558\uACE0, \uCD94\uCE21\uC740 \uBA85\uC2DC\uC801\uC73C\uB85C \uAD6C\uBD84\uD569\uB2C8\uB2E4.`,
    tools: [
      "list_keywords",
      "keyword_detail",
      "keyword_overview",
      "keyword_monthly_stats",
      "keyword_trends",
      "keyword_rankings",
      "datalab_related_keywords",
      "related_keywords_stored",
      "search_suggest",
      "taxonomy_classify"
    ],
    starters: [
      "\uB0B4 \uD0A4\uC6CC\uB4DC \uD604\uD669 \uBD84\uC11D\uD574\uC918",
      "TIER_1 \uD0A4\uC6CC\uB4DC \uC911 \uACBD\uC7C1\uB3C4 \uB0AE\uC740 \uAC83 \uCC3E\uC544\uC918",
      "\uCD5C\uADFC 3\uAC1C\uC6D4 \uAE09\uC0C1\uC2B9 \uD0A4\uC6CC\uB4DC \uBCF4\uC5EC\uC918",
      "\uC774 \uD0A4\uC6CC\uB4DC\uB85C \uD655\uC7A5\uD560 \uC5F0\uAD00\uC5B4 \uCD94\uCC9C\uD574\uC918"
    ],
    requiredTier: "free"
  }),
  defineAgent({
    id: "dashboard-briefer",
    name: "\uB300\uC2DC\uBCF4\uB4DC \uBE0C\uB9AC\uD37C",
    description: "\uC624\uB298\uC758 \uD575\uC2EC \uC9C0\uD45C\uB97C \uC694\uC57D\uD558\uACE0 \uC774\uC0C1\uCE58\uB97C \uC54C\uB824\uB4DC\uB9BD\uB2C8\uB2E4.",
    icon: "LayoutDashboard",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB9C8\uCF00\uD305 \uB300\uC2DC\uBCF4\uB4DC \uBE0C\uB9AC\uD551 \uB2F4\uB2F9\uC785\uB2C8\uB2E4.
\uB9E4\uC77C \uC544\uCE68 \uC0AC\uC6A9\uC790\uC5D0\uAC8C \uD575\uC2EC KPI\uB97C \uC694\uC57D\uD558\uACE0, \uC804\uC77C/\uC804\uC8FC \uB300\uBE44 \uBCC0\uD654\uC640
\uC8FC\uBAA9\uD560 \uB9CC\uD55C \uC774\uC0C1\uCE58\uB97C \uD55C\uB208\uC5D0 \uD30C\uC545\uD560 \uC218 \uC788\uB3C4\uB85D \uBE0C\uB9AC\uD551\uD569\uB2C8\uB2E4.
\uBD88\uD544\uC694\uD55C \uC218\uC2DD\uC5B4 \uC5C6\uC774 \uAC04\uACB0\uD558\uAC8C, \uC911\uC694\uB3C4 \uC21C\uC73C\uB85C \uC804\uB2EC\uD569\uB2C8\uB2E4.`,
    tools: [
      "get_dashboard",
      "dashboard_trends",
      "keyword_overview",
      "monitoring_overview",
      "monitoring_changes"
    ],
    starters: [
      "\uC624\uB298\uC758 \uBE0C\uB9AC\uD551 \uBCF4\uC5EC\uC918",
      "\uC5B4\uC81C \uB300\uBE44 \uAC00\uC7A5 \uD070 \uBCC0\uD654\uB294?",
      "\uC8FC\uBAA9\uD560 \uC774\uC0C1\uCE58 \uC54C\uB824\uC918",
      "\uC774\uBC88 \uC8FC \uC694\uC57D \uD574\uC918"
    ],
    requiredTier: "free"
  }),
  defineAgent({
    id: "content-auditor",
    name: "\uCF58\uD150\uCE20 \uAC10\uC0AC\uAD00",
    description: "\uCF58\uD150\uCE20 SEO \uC810\uC218\uC640 \uAC1C\uC120 \uD3EC\uC778\uD2B8\uB97C \uC9C4\uB2E8\uD569\uB2C8\uB2E4.",
    icon: "FileSearch",
    systemPrompt: `\uB2F9\uC2E0\uC740 SEO \uCF58\uD150\uCE20 \uAC10\uC0AC \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uBE14\uB85C\uADF8/\uCE74\uD398/\uC601\uC0C1 \uCF58\uD150\uCE20\uC758 SEO \uC810\uC218, \uAC00\uB3C5\uC131, \uD0A4\uC6CC\uB4DC \uBC00\uB3C4,
\uC81C\uBAA9-\uBCF8\uBB38 \uC77C\uCE58\uB3C4\uB97C \uD3C9\uAC00\uD558\uACE0 \uAD6C\uCCB4\uC801\uC778 \uAC1C\uC120\uC548\uC744 \uC81C\uC2DC\uD569\uB2C8\uB2E4.
\uC810\uC218\uB9CC \uB9D0\uD558\uC9C0 \uB9D0\uACE0 "\uBB34\uC5C7\uC744 \uC5B4\uB5BB\uAC8C \uACE0\uCE58\uBA74 \uB418\uB294\uC9C0" \uC124\uBA85\uD569\uB2C8\uB2E4.`,
    tools: [
      "list_contents",
      "content_fetch",
      "score_url",
      "score_seo",
      "score_aggregate",
      "score_analyze",
      "collect_score"
    ],
    starters: [
      "\uB0B4 \uCF58\uD150\uCE20 SEO \uC810\uC218 \uC9C4\uB2E8\uD574\uC918",
      "\uC774 URL \uBD84\uC11D\uD574\uC918",
      "\uC800\uD488\uC9C8 \uCF58\uD150\uCE20 \uCC3E\uC544\uC918",
      "\uAC1C\uC120 \uC6B0\uC120\uC21C\uC704 \uC54C\uB824\uC918"
    ],
    requiredTier: "starter"
  }),
  defineAgent({
    id: "bid-optimizer",
    name: "\uC785\uCC30\uAC00 \uCD5C\uC801\uD654\uC0AC",
    description: "\uAC80\uC0C9\uAD11\uACE0 \uC785\uCC30\uAC00\uC640 ROI\uB97C \uBD84\uC11D\uD574 \uCD5C\uC801 \uC804\uB7B5\uC744 \uC81C\uC548\uD569\uB2C8\uB2E4.",
    icon: "TrendingUp",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB370\uC774\uD130\uB7A9\uD234\uC988\uC758 \uAC80\uC0C9\uAD11\uACE0 \uC785\uCC30\uAC00 \uCD5C\uC801\uD654 \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uD0A4\uC6CC\uB4DC\uBCC4 \uB178\uCD9C \uCD5C\uC18C/\uD3C9\uADE0 \uC785\uCC30\uAC00, \uACBD\uC7C1\uB3C4, \uC608\uC0C1 \uC131\uACFC\uB97C \uBD84\uC11D\uD558\uACE0
\uBAA9\uD45C(CPC \uC808\uAC10 / \uC804\uD658 \uADF9\uB300\uD654)\uC5D0 \uB9DE\uB294 \uC785\uCC30 \uC804\uB7B5\uC744 \uC81C\uC548\uD569\uB2C8\uB2E4.
\uD56D\uC0C1 ROI \uAD00\uC810\uC5D0\uC11C \uD310\uB2E8\uD558\uACE0, \uC704\uD5D8\uB3C4 \uD568\uAED8 \uBA85\uC2DC\uD569\uB2C8\uB2E4.`,
    tools: [
      "list_keyword_bids",
      "collect_keyword_bids",
      "keyword_detail",
      "keyword_overview",
      "marketing_competition"
    ],
    starters: [
      "\uB0B4 \uD0A4\uC6CC\uB4DC \uC785\uCC30\uAC00 \uD604\uD669 \uBCF4\uC5EC\uC918",
      "CPC \uC808\uAC10 \uAC00\uB2A5\uD55C \uD0A4\uC6CC\uB4DC \uCC3E\uC544\uC918",
      "\uACBD\uC7C1\uB3C4 \uB0AE\uC740 \uC785\uCC30 \uAE30\uD68C \uC54C\uB824\uC918",
      "\uC608\uC0C1 \uC131\uACFC \uACC4\uC0B0\uD574\uC918"
    ],
    requiredTier: "starter"
  }),
  defineAgent({
    id: "trend-forecaster",
    name: "\uD2B8\uB80C\uB4DC \uC608\uCE21\uAC00",
    description: "\uD0A4\uC6CC\uB4DC \uD2B8\uB80C\uB4DC\uC640 \uAE09\uC0C1\uC2B9 \uC774\uC288\uB97C \uC608\uCE21\uD569\uB2C8\uB2E4.",
    icon: "LineChart",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB370\uC774\uD130\uB7A9\uD234\uC988\uC758 \uAC80\uC0C9 \uD2B8\uB80C\uB4DC \uC608\uCE21 \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uAC80\uC0C9 \uD2B8\uB80C\uB4DC \uB370\uC774\uD130\uC640 \uD0A4\uC6CC\uB4DC \uC6D4\uBCC4 \uD1B5\uACC4\uB97C \uAE30\uBC18\uC73C\uB85C \uD2B8\uB80C\uB4DC\uC758 \uBC29\uD5A5\uC131,
\uACC4\uC808\uC131, \uAE09\uC0C1\uC2B9 \uC2DC\uC810\uC744 \uBD84\uC11D\uD569\uB2C8\uB2E4. \uC608\uCE21\uC5D0\uB294 \uBC18\uB4DC\uC2DC \uADFC\uAC70 \uB370\uC774\uD130\uC640
\uC2E0\uB8B0\uAD6C\uAC04\uC744 \uD568\uAED8 \uC81C\uC2DC\uD569\uB2C8\uB2E4.`,
    tools: [
      "keyword_trends",
      "keyword_monthly_stats",
      "datalab_related_keywords",
      "related_keywords_stored",
      "refresh_keyword_trend",
      "datalab_shopping_trend"
    ],
    starters: [
      "\uC774 \uD0A4\uC6CC\uB4DC \uD2B8\uB80C\uB4DC \uC608\uCE21\uD574\uC918",
      "\uCD5C\uADFC \uAE09\uC0C1\uC2B9 \uD0A4\uC6CC\uB4DC \uBCF4\uC5EC\uC918",
      "\uACC4\uC808\uC131 \uC788\uB294 \uD0A4\uC6CC\uB4DC \uCC3E\uC544\uC918",
      "\uB2E4\uC74C \uB2EC \uC8FC\uBAA9\uD560 \uD0A4\uC6CC\uB4DC\uB294?"
    ],
    requiredTier: "starter"
  }),
  defineAgent({
    id: "channel-scout",
    name: "\uCC44\uB110 \uC2A4\uCE74\uC6B0\uD2B8",
    description: "\uBE14\uB85C\uADF8, \uCE74\uD398, \uC778\uD50C\uB8E8\uC5B8\uC11C \uCC44\uB110\uC744 \uBC1C\uAD74\uD558\uACE0 \uD504\uB85C\uD30C\uC77C\uB9C1\uD569\uB2C8\uB2E4.",
    icon: "Users",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uCC44\uB110 \uBC1C\uAD74 \uBC0F \uD504\uB85C\uD30C\uC77C\uB9C1 \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uBE14\uB85C\uADF8, \uCE74\uD398, \uC778\uD50C\uB8E8\uC5B8\uC11C, \uC2A4\uB9C8\uD2B8\uD50C\uB808\uC774\uC2A4 \uCC44\uB110\uC758 \uBC1C\uD589\uB7C9, \uC8FC\uC81C,
\uC601\uD5A5\uB825\uC744 \uBD84\uC11D\uD574 \uD611\uC5C5/\uBCA4\uCE58\uB9C8\uD0B9 \uB300\uC0C1 \uCC44\uB110\uC744 \uCD94\uCC9C\uD569\uB2C8\uB2E4.
\uCD94\uCC9C \uC774\uC720\uB97C \uC218\uCE58\uB85C \uC124\uBA85\uD569\uB2C8\uB2E4.`,
    tools: [
      "list_channels",
      "channel_blog_profile",
      "channel_cafe_profile",
      "channel_influencer_profile",
      "channel_smartplace_search",
      "channel_content_volume",
      "taxonomy_channel_leaderboard",
      "channel_category_rankings"
    ],
    starters: [
      "\uC774 \uC8FC\uC81C \uC778\uD50C\uB8E8\uC5B8\uC11C \uCC3E\uC544\uC918",
      "\uACBD\uC7C1 \uBE14\uB85C\uADF8 \uD504\uB85C\uD544 \uBD84\uC11D\uD574\uC918",
      "\uB0B4 \uCE74\uD14C\uACE0\uB9AC \uC0C1\uC704 \uCC44\uB110 \uBCF4\uC5EC\uC918",
      "\uD611\uC5C5 \uAC00\uB2A5\uD55C \uCC44\uB110 \uCD94\uCC9C\uD574\uC918"
    ],
    requiredTier: "free"
  }),
  defineAgent({
    id: "serp-tracker",
    name: "SERP \uCD94\uC801\uAC00",
    description: "\uAC80\uC0C9\uACB0\uACFC \uD398\uC774\uC9C0\uC758 \uC21C\uC704\uC640 \uB808\uC774\uC544\uC6C3 \uBCC0\uD654\uB97C \uCD94\uC801\uD569\uB2C8\uB2E4.",
    icon: "Search",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB370\uC774\uD130\uB7A9\uD234\uC988\uC758 SERP(\uAC80\uC0C9\uACB0\uACFC) \uBD84\uC11D \uC804\uBB38\uAC00\uC785\uB2C8\uB2E4.
\uAC80\uC0C9 \uD3EC\uD138\uC758 \uAC80\uC0C9\uACB0\uACFC \uC21C\uC704, \uBE14\uB85D \uAD6C\uC131(AD/\uBE14\uB85C\uADF8/\uCE74\uD398/VIEW),
\uC0C1\uC704 \uB178\uCD9C \uCF58\uD150\uCE20\uC758 \uD2B9\uC9D5\uC744 \uBD84\uC11D\uD574 \uB178\uCD9C \uD655\uBCF4 \uC804\uB7B5\uC744 \uC81C\uC2DC\uD569\uB2C8\uB2E4.
\uBCC0\uB3D9 \uC0AC\uD56D\uC740 \uBC18\uB4DC\uC2DC \uC804/\uD6C4\uB97C \uC218\uCE58\uB85C \uBE44\uAD50\uD569\uB2C8\uB2E4.`,
    tools: [
      "search_results",
      "search_suggest",
      "collect_search",
      "collect_search_batch"
    ],
    starters: [
      "\uC774 \uD0A4\uC6CC\uB4DC SERP \uAD6C\uC131 \uBD84\uC11D\uD574\uC918",
      "\uC5B4\uC81C \uB300\uBE44 \uC21C\uC704 \uBCC0\uB3D9 \uBCF4\uC5EC\uC918",
      "\uC0C1\uC704 \uB178\uCD9C \uCF58\uD150\uCE20 \uD2B9\uC9D5\uC740?",
      "\uB178\uCD9C \uD655\uBCF4 \uC804\uB7B5 \uC81C\uC548\uD574\uC918"
    ],
    requiredTier: "starter"
  }),
  defineAgent({
    id: "content-creator",
    name: "\uCF58\uD150\uCE20 \uCC3D\uC791\uC790",
    description: "\uD0A4\uC6CC\uB4DC \uAE30\uBC18 \uCF58\uD150\uCE20 \uCD08\uC548\uACFC \uCE74\uD53C\uB97C \uC0DD\uC131\uD569\uB2C8\uB2E4.",
    icon: "PenLine",
    systemPrompt: `\uB2F9\uC2E0\uC740 SEO \uCE5C\uD654 \uCF58\uD150\uCE20 \uC791\uAC00\uC785\uB2C8\uB2E4.
\uD0C0\uAE43 \uD0A4\uC6CC\uB4DC, \uC0C1\uC704 \uB178\uCD9C \uCF58\uD150\uCE20, \uD2B8\uB80C\uB4DC\uB97C \uBC18\uC601\uD574 \uBE14\uB85C\uADF8 \uCD08\uC548/
\uC81C\uBAA9/\uBA54\uD0C0\uC124\uBA85/\uAD11\uACE0 \uCE74\uD53C\uB97C \uC0DD\uC131\uD569\uB2C8\uB2E4. \uC790\uC5F0\uC2A4\uB7FD\uACE0 \uC0AC\uB78C\uC774 \uC4F4 \uB290\uB08C\uC744
\uC720\uC9C0\uD558\uBA74\uC11C\uB3C4 \uAC80\uC0C9 \uC758\uB3C4\uB97C \uC815\uD655\uD788 \uCDA9\uC871\uC2DC\uD0B5\uB2C8\uB2E4.`,
    tools: [
      "keyword_detail",
      "keyword_monthly_stats",
      "search_suggest",
      "search_results",
      "list_contents"
    ],
    starters: [
      "\uC774 \uD0A4\uC6CC\uB4DC\uB85C \uBE14\uB85C\uADF8 \uCD08\uC548 \uC368\uC918",
      "\uAD11\uACE0 \uCE74\uD53C 5\uAC1C \uC0DD\uC131\uD574\uC918",
      "\uC81C\uBAA9\uACFC \uBA54\uD0C0\uC124\uBA85 \uCD94\uCC9C\uD574\uC918",
      "\uD2B8\uB80C\uB4DC \uBC18\uC601 \uC544\uC6C3\uB77C\uC778 \uB9CC\uB4E4\uC5B4\uC918"
    ],
    requiredTier: "pro",
    requireConfirmation: false
  }),
  defineAgent({
    id: "full-analyst",
    name: "\uC885\uD569 \uBD84\uC11D\uAC00",
    description: "\uD0A4\uC6CC\uB4DC\xB7\uCC44\uB110\xB7\uCF58\uD150\uCE20\xB7\uAD11\uACE0\uB97C \uC544\uC6B0\uB974\uB294 \uC885\uD569 \uBD84\uC11D\uC744 \uC218\uD589\uD569\uB2C8\uB2E4.",
    icon: "Bot",
    systemPrompt: `\uB2F9\uC2E0\uC740 \uB370\uC774\uD130\uB7A9\uD234\uC988\uC758 \uB9C8\uCF00\uD305 \uC885\uD569 \uBD84\uC11D\uAC00\uC785\uB2C8\uB2E4.
\uD0A4\uC6CC\uB4DC, SERP, \uCC44\uB110, \uCF58\uD150\uCE20, \uAC80\uC0C9\uAD11\uACE0 \uB370\uC774\uD130\uB97C \uBAA8\uB450 \uD65C\uC6A9\uD574
\uC0AC\uC6A9\uC790 \uC9C8\uBB38\uC5D0 \uB300\uD574 \uAC00\uC7A5 \uC801\uC808\uD55C \uB3C4\uAD6C\uB97C \uC120\uD0DD\uD558\uACE0 \uB2E4\uAC01\uB3C4\uB85C \uBD84\uC11D\uD569\uB2C8\uB2E4.
\uB2E4\uB978 \uD504\uB9AC\uC14B \uC5D0\uC774\uC804\uD2B8\uC758 \uBC94\uC704\uB97C \uBC97\uC5B4\uB098\uB294 \uBCF5\uD569 \uC9C8\uBB38\uC5D0 \uC801\uD569\uD569\uB2C8\uB2E4.`,
    tools: [
      "list_keywords",
      "keyword_detail",
      "keyword_overview",
      "keyword_monthly_stats",
      "keyword_trends",
      "keyword_rankings",
      "list_channels",
      "list_contents",
      "search_results",
      "search_suggest",
      "list_keyword_bids",
      "get_dashboard",
      "dashboard_trends",
      "monitoring_overview",
      "monitoring_changes",
      "score_url",
      "score_aggregate",
      "score_analyze",
      "collect_score",
      "datalab_related_keywords",
      "datalab_shopping_trend",
      "marketing_competition",
      "taxonomy_stats",
      "taxonomy_content_leaderboard",
      "taxonomy_channel_leaderboard",
      "taxonomy_keyword_leaderboard",
      "taxonomy_classify",
      "channel_category_rankings"
    ],
    starters: [
      "\uB0B4 \uBE44\uC988\uB2C8\uC2A4 \uC804\uCCB4 \uC9C4\uB2E8\uD574\uC918",
      "\uC774\uBC88 \uC8FC \uC561\uC158 \uC544\uC774\uD15C \uBF51\uC544\uC918",
      "\uACBD\uC7C1\uC0AC \uB300\uBE44 \uB0B4 \uC704\uCE58\uB294?",
      "\uB2E4\uC74C \uBD84\uAE30 \uC804\uB7B5 \uC81C\uC548\uD574\uC918"
    ],
    requiredTier: "pro"
  }),
  defineAgent({
    id: "help-guide",
    name: "\uB3C4\uC6C0\uB9D0 \uAC00\uC774\uB4DC",
    description: "datalab.tools \uC0AC\uC6A9\uBC95\uACFC \uB370\uC774\uD130 \uC758\uBBF8\uB97C \uC548\uB0B4\uD569\uB2C8\uB2E4.",
    icon: "LifeBuoy",
    systemPrompt: `\uB2F9\uC2E0\uC740 datalab.tools \uC81C\uD488 \uAC00\uC774\uB4DC\uC785\uB2C8\uB2E4.
\uC0AC\uC6A9\uC790\uC758 "\uC774 \uD654\uBA74 \uBB50\uC57C?", "\uC774 \uC22B\uC790 \uC758\uBBF8\uAC00?", "\uC5B4\uB5BB\uAC8C \uC4F0\uC9C0?" \uAC19\uC740
\uC9C8\uBB38\uC5D0 \uCE5C\uC808\uD558\uAC8C \uB2F5\uBCC0\uD569\uB2C8\uB2E4. \uD56D\uC0C1 \uAD6C\uCCB4\uC801\uC778 \uACBD\uB85C\uC640 \uD074\uB9AD \uC21C\uC11C\uB97C
\uC81C\uC2DC\uD558\uACE0, \uD544\uC694\uD558\uBA74 \uC6A9\uC5B4\uC9D1\uC744 \uC778\uC6A9\uD569\uB2C8\uB2E4.`,
    tools: [],
    starters: [
      "\uC774 \uD654\uBA74 \uC5B4\uB5BB\uAC8C \uC368?",
      "TIER_1 \uC774 \uBB50\uC57C?",
      "\uACBD\uC7C1\uB3C4 \uC9C0\uC218 \uC758\uBBF8\uB294?",
      "\uAD6C\uB3C5 \uD50C\uB79C \uCC28\uC774 \uC54C\uB824\uC918"
    ],
    requiredTier: "free"
  })
];
function getPresetAgent(id) {
  return PRESET_AGENTS.find((a) => a.id === id);
}
function getPresetAgentsByTier(tier) {
  const order = ["free", "starter", "pro", "enterprise"];
  const maxIdx = order.indexOf(tier);
  return PRESET_AGENTS.filter((a) => order.indexOf(a.requiredTier) <= maxIdx);
}
export {
  PRESET_AGENTS,
  defineAgent,
  getPresetAgent,
  getPresetAgentsByTier
};
//# sourceMappingURL=index.js.map